/** MI DOMINO — internationalisation (ES / EN).
 *  First typed module carved out of the legacy client. */
export type Lang = 'es' | 'en';

export let LANG: Lang = 'es';
try { LANG = (localStorage.getItem('lang') as Lang) || 'en'; } catch { /* no storage */ }

export const T: Record<string, [string, string]> = {
  newMatch: ['NUEVA PARTIDA', 'NEW MATCH'],
  store: ['✨ TIENDA', '✨ SHOP'],
  dash: ['MI DASHBOARD', 'MY DASHBOARD'],
  mode: ['Modo de juego', 'Game mode'],
  feltLbl: ['Paño de la mesa', 'Table felt'],
  fichasLbl: ['Fichas', 'Dominos'],
  chatPh: ['Habla, compay...', 'Talk to the table...'],
  noVoy: ['¡NO VOY! 🙅', 'PASS 🙅'],
  you: ['TÚ', 'YOU'],
  undo: ['↩ Deshacer', '↩ Undo'],
  tabMesa: ['Mesa', 'Table'],
  tabDash: ['Dashboard', 'Dashboard'],
  storeWord: ['Tienda', 'Shop'],
  help: ['❓ Cómo jugar', '❓ How to play'],
  account: ['Cuenta', 'Account'],
  acctProfile: ['📝 Editar perfil', '📝 Edit profile'],
  acctPassword: ['🔐 Cambiar contraseña', '🔐 Change password'],
  acctLogout: ['🚪 Cerrar sesión', '🚪 Log out'],
  acctLogoutAll: ['🚪🚪 Cerrar sesión en todos los dispositivos', '🚪🚪 Log out on every device'],
  acctLogin: ['🔑 Entrar / Crear cuenta', '🔑 Sign in / Create account'],
  acctInstall: ['📲 Instalar app', '📲 Install app'],
  quickTitle: ['Frases rápidas', 'Quick phrases'],
  rematch: ['🔁 ¡REVANCHA!', '🔁 REMATCH!'],
  rematchWait: ['Esperando a', 'Waiting for'],
  rematchIn: ['¡Tú estás dentro!', "You're in!"],
  backLobby: ['VOLVER AL LOBBY', 'BACK TO LOBBY'],
  guest: ['Invitado', 'Guest'],
  leftEnd: ['◀ Punta izquierda', '◀ Left end'],
  rightEnd: ['Punta derecha ▶', 'Right end ▶'],
  galTitle: ['🎉 LA GALERÍA', '🎉 THE GALLERY'],
  galFoot: ['💬 chat libre · 🎥 video solo PRO', '💬 free chat · 🎥 video is PRO-only'],
  back: ['VOLVER A LA MESA', 'BACK TO THE TABLE'],
  nextHand: ['SIGUIENTE MANO', 'NEXT HAND'],
  countAll: ['CUENTA TODAS LAS FICHAS…', 'COUNT EVERY DOMINO…'],
  apply: ['APLICAR PUNTOS', 'APPLY POINTS'],
  countIntro: ['Las fichas se voltean. <b>Toca CADA una para contarla</b> — aquí no hay nada automático.',
    'The dominos flip over. <b>Tap EACH domino to count it</b> — nothing is automatic at this table.'],
  us: ['NOSOTROS', 'US'],
  them: ['ELLOS', 'THEM'],
  hintsLbl: ['Ayudas en la mesa', 'Table hints'],
  hintOn: ['✋ Mostrar dónde colocar (novato)', '✋ Show where to place (rookie)'],
  hintOff: ['🔥 Sin ayudas — Matatán', '🔥 No hints — Pro'],
  soundLbl: ['Sonido', 'Sound'],
  sndOn: ['🔊 Sonido activado', '🔊 Sound on'],
  sndOff: ['🔇 Silencio', '🔇 Muted'],
  mode500: ['A 500 — Con premios (Capicú/Chuchazo/Tranque)', 'To 500 — With prizes (Capicú/Chuchazo/Tranque)'],
  mode200: ['A 200 — Casual (sin bonos)', 'To 200 — Casual (no bonuses)'],
  feltGreen: ['Verde Clásico', 'Classic Green'],
  feltWine: ['Vino Dominicano', 'Dominican Wine'],
  feltOcean: ['Azul Caribe', 'Caribbean Blue'],
  feltRoyal: ['Púrpura Real 🔒 (Rango 5)', 'Royal Purple 🔒 (Rank 5)'],
  skinIvory: ['Marfil Clásico', 'Classic Ivory'],
  skinMid: ['Medianoche', 'Midnight'],
  skinGold: ['Oro Negro 🔒 (Rango 3)', 'Black Gold 🔒 (Rank 3)'],
  skinCoral: ['Coral', 'Coral'],
  woodLbl: ['Madera de la mesa', 'Table wood'],
  woodClassic: ['Madera clásica', 'Classic wood'],
  sceneLbl: ['Ambiente', 'Scene'],
  sceneClassic: ['🎴 Salón clásico', '🎴 Classic room'],
  scenePlaya: ['🏖️ Playa', '🏖️ Beach'],
  sceneMalecon: ['🌅 Atardecer en el Malecón', '🌅 Malecón sunset'],
  sceneNoche: ['🌃 Colmado de noche', '🌃 Corner store at night'],
  scenePatio: ['🌴 Patio tropical', '🌴 Tropical patio'],
  sceneCasino: ['🎰 Casino', '🎰 Casino'],
  sceneCafe: ['☕ Cafetería', '☕ Café'],
  galFootLine: ['💬 chat libre · 🎥 video solo PRO', '💬 free chat · 🎥 video PRO-only'],
  score: ['Marcador', 'Score'],
  matchTo: ['Partida a', 'Match to'],
  conPremios: ['CON PREMIOS', 'WITH PRIZES'],
  casual: ['Casual', 'Casual'],
  premiosLbl: ['PREMIOS manos 1–4', 'PRIZES hands 1–4'],
  mano: ['Mano', 'Hand'],
  sinPremio: ['Sin premio esta mano', 'No prize this hand'],
  myNumbers: ['📈 Mis números', '📈 My numbers'],
  recentMatches: ['🕐 Últimas partidas', '🕐 Recent matches'],
  myTable: ['🎨 Mi mesa', '🎨 My table'],
  howXP: ['⚡ Cómo ganar XP', '⚡ How to earn XP'],
  myPurch: ['🎒 Mis compras', '🎒 My purchases'],
  tapEquip: ['— toca para equipar', '— tap to equip'],
  play: ['🎲 JUGAR', '🎲 PLAY'],
  edit: ['👤 EDITAR', '👤 EDIT'],
  winRate: ['Victorias', 'Win rate'],
  partidas: ['🏆 Partidas', '🏆 Matches'],
  manos: ['✋ Manos', '✋ Hands'],
  rachaAct: ['Racha actual', 'Current streak'],
  loginStreak: ['🎁 Racha diaria', '🎁 Daily streak'],
  mejorRacha: ['Mejor racha', 'Best streak'],
  noMatches: ['Aún no hay partidas. ¡Dale a JUGAR!', 'No matches yet. Hit PLAY!'],
  victoria: ['¡Victoria!', 'Victory!'],
  derrota: ['Derrota', 'Defeat'],
  hazte: ['HAZTE PRO 🎥', 'GO PRO 🎥'],
  sinEquipo: ['Sin equipo', 'No team'],
  mesaClasica: ['Mesa clásica de madera — visita la TIENDA para bedazzlearla ✨',
    'Classic wood table — visit the SHOP to bedazzle it ✨'],
  equip: ['ACTIVAR', 'EQUIP'],
  unequip: ['QUITAR', 'REMOVE'],
  close: ['CERRAR', 'CLOSE'],
  balance: ['Tu balance', 'Your balance'],
  earnHint: ['Gana 🪙 jugando: +25 por mano ganada · +150 por partida ganada.',
    'Earn 🪙 by playing: +25 per hand won · +150 per match won.'],
  soloBtn: ['JUGAR SOLO (vs máquina)', 'PLAY SOLO (vs AI)'],
  createBtn: ['CREAR MESA ONLINE', 'CREATE ONLINE TABLE'],
  quickBtn: ['⚡ BUSCAR MESA (rápido)', '⚡ FIND A TABLE (quick)'],
  joinBtn: ['UNIRSE', 'JOIN'],
  namePh: ['Tu nombre', 'Your name'],
  codePh: ['CÓDIGO', 'CODE'],
  rapidBtn: ['⚡ CONTAR RÁPIDO', '⚡ RAPID COUNT'],
  spaceHint: ['💻 Barra espaciadora: cuenta ficha por ficha', '💻 Spacebar: count domino by domino'],
  xpTotal: ['XP total', 'Total XP'],
  capicusL: ['🎯 Capicús', '🎯 Capicús'],
  chuchazosL: ['💥 Chuchazos', '💥 Chuchazos'],
  tranquesL: ['🔒 Tranques', '🔒 Tranques'],
  rankScale: ['🏅 ESCALA DE RANGOS — ¿hasta dónde llegas?', '🏅 RANK SCALE — how far can you climb?'],
  colGot: ['¡TE SALIÓ!', 'YOU PULLED!'],
  colNote: ['🔗 Ficha única con número de serie — lista para ser NFT coleccionable.',
    '🔗 Unique serial-numbered domino — ready to become a collectible NFT.'],
  colPack: ['SOBRE DE COLECCIÓN', 'COLLECTOR PACK'],
  colOpen: ['ABRIR SOBRE', 'OPEN PACK'],
  colHow: ['Se ganan por RANGO y VICTORIAS 🏆 — o abre sobres con PhilCoins.',
    'Earned through RANK-UPS and WINS 🏆 — or open packs with PhilCoins.'],
  howXPBody: [
    '✋ Mano ganada <b>+10</b> · 🔒 Tranque <b>+25</b> · ✋🔒 Tranque con la mano <b>+30</b><br>🎯 Capicú <b>+25</b> · 💥 Chuchazo <b>+40</b><br>🏆 Victoria <b>+50</b> + bono por paliza (hasta <b>+30</b>)<br>🔥 Racha de 2+ victorias <b>×1.25</b> · Racha de 4+ <b>×1.5</b><br>⬆️ Subir de rango = <b>lluvia de monedas de recompensa</b> 🪙',
    '✋ Hand won <b>+10</b> · 🔒 Tranque <b>+25</b> · ✋🔒 Tranque with the hand <b>+30</b><br>🎯 Capicú <b>+25</b> · 💥 Chuchazo <b>+40</b><br>🏆 Victory <b>+50</b> + blowout bonus (up to <b>+30</b>)<br>🔥 2+ win streak <b>×1.25</b> · 4+ streak <b>×1.5</b><br>⬆️ Rank up = <b>reward coin shower</b> 🪙',
  ],
};

export function t(k: string): string {
  const v = T[k];
  return v ? (LANG === 'en' ? v[1] : v[0]) : k;
}

export function setLang(l: Lang): void {
  LANG = l;
  try { localStorage.setItem('lang', l); } catch { /* no storage */ }
}
